import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Lock = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Lock" {...props}>
    <path d="M12 13C12.5523 13 13 13.4477 13 14V18H11V14C11 13.4477 11.4477 13 12 13Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M12 1C15.178 1 17.0803 1.90913 18.0879 3.4541C19.0273 4.89485 19 6.66023 19 7.7998V9.41602C20.7659 10.1876 22 11.9497 22 14V18C22 20.7614 19.7614 23 17 23H7C4.23858 23 2 20.7614 2 18V14C2 11.9497 3.23409 10.1876 5 9.41602V7.7998C5 6.66023 4.9727 4.89485 5.91211 3.4541C6.9197 1.90913 8.82196 1 12 1ZM7 11C5.34315 11 4 12.3431 4 14V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V14C20 12.3431 18.6569 11 17 11H7ZM12 3C9.17852 3 8.08042 3.79099 7.58789 4.5459C7.02764 5.40495 7 6.53955 7 7.7998V9H17V7.7998C17 6.53955 16.9724 5.40495 16.4121 4.5459C15.9196 3.79099 14.8215 3 12 3Z" fill="#000" />
  </StyledIcon>
));

Lock.displayName = 'Lock';

export { Lock };
